<template>
  <div>
    <TerminationOption
      :assetComponent="assetComponent"
      :form="form"
      :currencyCodes="currencyCodes"
    />
  </div>
</template>

<script>
import SetTermination from "../../models/commands/SetTermination";
import TerminationOption from "../forms/options/TerminationOptionEvent";
import Termination from "@/models/options/Termination";

export default {
  components: {
    TerminationOption
  },
  props: {
    assetComponent: {
      type: Object,
      required: true
    },
    currencyCodes: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      form: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let termination = null;
      if (this.assetComponent.termination !== null) {
        termination = this.assetComponent.termination;
        this.$set(termination, 'isTermination', true);
      } else {
        termination = Termination.createNew();
        this.$set(termination, 'isTermination', false);
      }

      this.form = termination;
    },

    cancel() {
      this.init();
    },

    save() {
      let termination = null;
      let transformedTermination = null;
      if (this.form.isTermination) {
        termination = Termination.createFromForm(this.form);
        transformedTermination =  {
          rateCurrency: termination.currencyCode,
          date: termination.date,
          externalId: termination.externalId,
          isFinePresented: termination.isFinePresented,
          isFineWillBePayed: termination.isFineWillBePayed,
          isSure: termination.isSure,
          paymentDate: termination.paymentDate,
          rateValue: termination.rate,
        }
      }

      const command = new SetTermination(
        this.assetComponent.idInDB,
        transformedTermination
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
